import { render, staticRenderFns } from "./com-community-search.vue?vue&type=template&id=21fa9ebc&"
import script from "./com-community-search.vue?vue&type=script&lang=js&"
export * from "./com-community-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports